import { useState } from "react";
import { useIntl } from "react-intl";

import { MoreDetailsDrawer } from "@/components/MoreDetailsDrawer/MoreDetailsDrawer";

export const TermsAndConditionsAlert = () => {
  const intl = useIntl();
  const [moreDetailsOpen, setMoreDetailsOpen] = useState(false);

  return (
    <>
      <div className="rounded-2xl border border-stroke-neutral-soft bg-surface-background p-3 text-xs text-text-primary">
        {intl.formatMessage(
          {
            defaultMessage:
              'By tapping "Continue to Payment" you agree with the <button>booking terms</button>',
            description:
              "Disclaimer text informing users that by proceeding with the payment they agree to the booking terms and conditions",
          },
          {
            button: (chunks) => (
              <button
                type="button"
                onClick={() => setMoreDetailsOpen(true)}
                className="underline"
              >
                {chunks}
              </button>
            ),
          },
        )}
      </div>

      <MoreDetailsDrawer
        open={moreDetailsOpen}
        onClose={() => setMoreDetailsOpen(false)}
      />
    </>
  );
};
